import { FunctionComponent, useEffect } from "react";
import { NODES_LIST_TEST_ID, REMOVE_MEMBER_BUTTON_TEST_ID } from "constants/test";
import { useEditor } from "../editor";
import XMarkIcon from "@heroicons/react/24/outline/XMarkIcon";

export interface NodesListProps {
  onSelect: (index: number) => void;
  exclude?: number[];
  onRemove?: (index: number) => void;
}

const NodesList: FunctionComponent<NodesListProps> = ({ exclude = [], onSelect, onRemove }) => {
  const { setHoveredListItemIndex, configurator, model } = useEditor();
  const customizers = configurator.options.customizers;

  useEffect(() => {
    return () => setHoveredListItemIndex(undefined);
  }, []);

  return !model ? null : (
    <div data-testid={NODES_LIST_TEST_ID}>
      {Object.values(model.nodes)
        .filter((n) => n.type === "Mesh")
        .map((mesh, i) => {
          const name = customizers.find((x) => x.targetIndexes.includes(i))?.name;
          return exclude.includes(i) ? null : (
            <div
              onMouseEnter={() => setHoveredListItemIndex(i)}
              onMouseLeave={() => setHoveredListItemIndex(undefined)}
              onClick={() => onSelect(i)}
              key={mesh.uuid}
              className="h-9 flex items-center group justify-between px-4 bg-gray-100 hover:bg-gray-200 cursor-pointer border-b"
            >
              {name ? name : mesh.name}
              {!onRemove ? null : (
                <XMarkIcon
                  data-testid={REMOVE_MEMBER_BUTTON_TEST_ID}
                  onClick={() => onRemove(i)}
                  className="opacity-0 group-hover:opacity-100 w-4 cursor-pointer"
                />
              )}
            </div>
          );
        })}
    </div>
  );
};

export default NodesList;
